import { useLocation, useNavigate } from "@entry/navigation";
import { useState } from "react";

import { TextInput } from "@components/Input";
import { AddressSuggestionList } from "@components/List";
import { OnboardingLayoutProps } from "@components/OnboardingLayout";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Routes } from "@ctypes";
import { EntryStepLayout as OnboardingLayout } from "@entry/EntryStepLayout";
import { useAddressSuggestion } from "@hooks";
import { Translations, i18n } from "@i18n";
import { EmployerAutofillRouteProps } from "./types";

export const EmployerAutofillRoute = () => {
  const navigate = useNavigate();

  const location = useLocation();

  const { placeId, fullAddress } = location.state as EmployerAutofillRouteProps;

  const [address, setAddress] = useState(fullAddress);

  const isDirty = address !== fullAddress;

  const { data } = useAddressSuggestion({
    input: address,
    skip: !isDirty,
  });

  const handleSubmit = () => {
    navigate(Routes.EmployerAddressConfirmation, { state: { placeId } });
  };

  const props: OnboardingLayoutProps = {
    title: i18n.t(Translations.EmployerAutofillRouteTitle),
    subContent: <AddressSuggestionList data={data} flow="employer" />,
    ...(!isDirty && {
      cta: {
        primary: {
          title: i18n.t(Translations.EmployerAutofillRoutePrimaryCTA),
          onClick: handleSubmit,
        },
      },
    }),
  };

  return (
    <OnboardingLayout {...props}>
      <TextInput
        label={i18n.t(Translations.EmployerAutofillRouteAddressLabel)}
        placeholder={i18n.t(Translations.EmployerAutofillRouteAddressPlaceholder)}
        value={address}
        onChangeText={(value) => setAddress(value)}
      />
      <Spacing size={SpacingSizes.M} />
    </OnboardingLayout>
  );
};
